<template>
  <div>
    <v-row no-gutters class="form-group" v-if="!noLabel">
      <span v-if="label !== ''" class="item-label">{{ label }}</span>
      <span v-else class="item-label" style="color:white" />
      <label class="form-group-label">
        <span v-if="required && !requiredMarkHidden" class="mandatory">必須</span>
      </label>
      <v-spacer />
      <v-chip v-if="!readonly" pill small dense class="support-input-date" @click="onClosingPrevNextButtonClick(-1)"><v-icon style="width:12px">mdi-chevron-left</v-icon></v-chip>
      <v-chip v-if="!readonly" pill small dense class="support-input-date" @click="onColosingDateButtonClick(10)">10日締</v-chip>
      <v-chip v-if="!readonly" pill small dense class="support-input-date" @click="onColosingDateButtonClick(20)">20日締</v-chip>
      <v-chip v-if="!readonly" pill small dense class="support-input-date" @click="onColosingDateButtonClick(99)">末日締</v-chip>
      <v-chip v-if="!readonly" pill small dense class="support-input-date" @click="onClosingPrevNextButtonClick(1)"><v-icon style="width:12px">mdi-chevron-right</v-icon></v-chip>
    </v-row>
    <v-row no-gutters class="py-0 range-style" :style="'margin-top: 1px; background-color:' + (required && !readonly ? '#FFEDEE;' : 'white;') + (readonly ? 'border-bottom: 1px solid #1F2B38' : 'border: 1px solid #CDD6DD; border-radius:5px;')">
      <v-col class="py-0 d-flex" :cols="12">
        <div class="pl-0" style="display: inline-block; width:40%; min-width: 105px;">
          <dd-date-box-inside
            v-on="computedListeners"
            v-bind="computedProps"
            v-model="innerFromDate"
            label=""
            ref="fromDate"
            :readonly="readonly"
            :required="required || requiredFrom"
            :placeholder="phtext"
            :tabindex="readonly ? -1 : 0"
            @click="hideCalendar"
            :isOuterErrorMessage="true"
            :outerErrorMessage.sync="fromErrorMessage"
          />
        </div>
        <div class="pl-1 pr-0 pt-1" style="display: inline-block;">～</div>
        <div class="px-0" style="display: inline-block;width:40%; min-width: 105px;">
          <dd-date-box-inside
            v-on="computedListeners"
            v-bind="computedProps"
            v-model="innerToDate"
            label=""
            ref="toDate"
            :readonly="readonly"
            :required="required || requiredTo"
            :placeholder="phtext"
            :tabindex="readonly ? -1 : 0"
            @click="hideCalendar"
            :isOuterErrorMessage="true"
            :outerErrorMessage.sync="toErrorMessage"
          />
        </div>
        <v-spacer />
        <div class="pr-1" style="float:right;padding-top:2px">
          <v-menu v-if="!readonly" v-model="isShowCalendar" :close-on-content-click="false" origin="top left">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-on="on"
                v-bind="attrs"
                color="primary"
                elevation="0"
                tabindex=-1
                icon
                dark
                small
                @click="onIconClick">
                <svg data-name="Icon - Calender" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                  <path d="M15.8,4A2.913,2.913,0,0,0,13,2V0H11V2H5V0H3V2A2.913,2.913,0,0,0,.2,4Z" fill="#83bde5"/>
                  <path d="M0,5v8a2.946,2.946,0,0,0,3,3H13a2.946,2.946,0,0,0,3-3V5Zm5,8H3V11H5ZM5,9H3V7H5Zm4,4H7V11H9ZM9,9H7V7H9Zm4,0H11V7h2Z" fill="#83bde5"/>
                </svg>
              </v-btn>
            </template>
            <v-card elevation=0 v-if="isShowCalendar">
              <v-card-text>
                <v-row no-gutters>
                  <v-col :cols="8" style="border-right:0.1px solid #e8e8e8;">
                    <v-row style="background-color:#E9F1F7; height:28px" no-gutters>
                      <v-col :cols="12" class="px-1">
                        <span style="display: inline-block;width:90px;" class="px-1 input-info">選択日付：</span>
                        <span class="px-0 input-info">{{ dispFrom }}</span>
                        <span class="px-1 input-info">～</span>
                        <span class="px-0 input-info">{{ dispTo }}</span>
                      </v-col>
                    </v-row>
                    <hr style="border-top:0.1px solid #c8c8c8;" />
                    <v-row style="background-color:#FFF; height:25px" no-gutters>
                      <v-col :cols="12" class="px-1 py-0">
                        <span style="display: inline-block;width:80px;" class="px-1 input-info">指定方法：</span>
                        <span style="display: inline-block;">
                          <v-radio-group v-if="useMode === 'search'" v-model="pickerType" label="" row dense>
                            <dd-radio-button
                              v-for="item in pickerActionsForSearch"
                              :key="item.value"
                              :value="item.value"
                              :label="item.label"
                              style="margin-right: 10px !important;"
                            />
                          </v-radio-group>
                          <v-radio-group v-else v-model="pickerType" label="" row dense>
                            <dd-radio-button
                              v-for="item in pickerActionsForInput"
                              :key="item.value"
                              :value="item.value"
                              :label="item.label"
                              style="margin-right: 10px !important;"
                            />
                          </v-radio-group>
                        </span>
                      </v-col>
                    </v-row>
                    <hr style="border-top:0.1px solid #e8e8e8;" />
                    <vc-date-picker
                      ref="vcCalendar"
                      v-model="calendarRangeDate"
                      style="border: none"
                      :columns="$screens({ default: 1, lg: 2 })"
                      :step="1"
                      :model-config="modelConfig"
                      :locale="locale"
                      :is-range="isRange"
                      :is-required="calendarIsRequired"
                      :max-date="calendarMax"
                      :min-date="calendarMin"
                      @dayclick="onCalendarClick"
                      @popoverDidShow="handleShow"
                    />
                    <hr style="border-top:0.1px solid #e8e8e8;" />
                    <v-row class="mt-1 px-2" style="background-color:#FFF; height:35px" no-gutters>
                      <dd-custom-button dense :disabled="selectedMode === 1" @click="onTekiyoClick">適用</dd-custom-button>
                      <dd-transparent-button :minWidth="80" @click="hideCalendar">キャンセル</dd-transparent-button>
                    </v-row>
                  </v-col>
                  <v-col :cols="4" class="px-1 py-2">
                    <v-row no-gutters justify="center">
                      <div v-for="support in supportActions" :key="support.value">
                        <span v-if="support.usePicker === null || support.usePicker === pickerType">
                          <input type="radio" v-model="selectedSupport" :id="support.value" name="support" :value="support.value" @click="onClickSupportAction(support.value)"/>
                          <label class="support" :for="support.value">
                            {{ support.label }}
                          </label>
                        </span>
                      </div>
                    </v-row>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-menu>
        </div>
      </v-col>
    </v-row>
    <v-row no-gutters v-if="dispMonthJumper">
      <a
        class="month-jumper zoom-hover"
        @click="onMonthJumperButtonClick(1)"
        >
        <v-icon color="#83bde5" style="margin-bottom: 2px;">mdi-chevron-left</v-icon>
        先月
      </a>
      <v-spacer/>
      <a
        class="month-jumper zoom-hover"
        @click="onMonthJumperButtonClick(0)"
        >
        今月
      </a>
      <v-spacer/>
      <a
        class="month-jumper zoom-hover"
        @click="onMonthJumperButtonClick(2)"
        >
        翌月
        <v-icon color="#83bde5" style="margin-bottom: 2px;">mdi-chevron-right</v-icon>
      </a>
    </v-row>
    <div class="range-style-message-area error--text" v-if="fromErrorMessage || toErrorMessage">
      <div class="range-style-message" style="width: calc(40% + 14.11px); min-width: calc(111px + 14.11px);">
        {{ ![undefined, null].includes(fromErrorMessage) ? fromErrorMessage : '' }}
      </div>
      <div class="range-style-message" style="flex-grow: 1; flex-basis: 0;">
        {{ ![undefined, null].includes(toErrorMessage) ? toErrorMessage : '' }}
      </div>
    </div>
  </div>
</template>
<script>
import { VTextField } from 'vuetify/lib'
import controls from '@/rahmen/controls'
import inputMixin from '@/mixins/inputMixins'
import date from '@/ddv2.library/date'
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'

import DdCustomButton from '@/components/DdCustomButton'
import DdDateBoxInside from '@/components/DdDateBoxInside'
// import DdIconButtonWithTooltip from '@/components/DdIconButtonWithTooltip'
import DdRadioButton from '@/components/DdRadioButton'
import DdTransparentButton from '@/components/DdTransparentButton'

/**
 * @file DDv2用日付入力
 * @namespace components
 */

/**
 * @vue-prop {Boolean} [required=false] - 必須有無
 * @vue-prop {String} [max='']- 許容最大値(デフォルト:2999/12/31)
 * @vue-prop {String} [min=''] - 許容最小値(デフォルト:2000/01/01)
 * @vue-prop {String} [errorMessages=''] - エラーメッセージ
 * @see https://vuetifyjs.com/ja/api/v-text-field/
 * @example
  <dd-date-box
    label="適用開始日"
    v-model="dateValue"
    max="2099/12/31"
    min="2000/01/01"/>
 */
export default {
  name: 'DdDateRangeBox',
  extends: VTextField,
  components: {
    DdCustomButton,
    DdDateBoxInside,
    // DdIconButtonWithTooltip,
    DdRadioButton,
    DdTransparentButton
  },
  mixins: [inputMixin],
  props: {
    /**
     * ラベル
     */
    label: String,
    /*
     * From日付
     */
    fromDate: {
      type: String,
      default: ''
    },
    /**
     * To日付
     */
    toDate: {
      type: String,
      default: ''
    },
    /**
     * 必須指定
     */
    required: {
      type: Boolean,
      default: false
    },
    /**
     * 必須指定(FROMのみ)
     * Required優先
     */
    requiredFrom: {
      type: Boolean,
      default: false
    },
    /**
     * 必須指定(TOのみ)
     * Required優先
     */
    requiredTo: {
      type: Boolean,
      default: false
    },
    /**
     * 入力可能最大値
     */
    max: String,
    /**
     * 入力可能最小値
     */
    min: String,
    /**
     * 表示エラーメッセージ
     */
    errorMessages: String,
    /**
     * タイトル表示
     */
    no_title: {
      type: Boolean,
      default: true
    },
    /**
     * ツールチップテキスト
     */
    tooltipText: {
      type: String,
      default: ''
    },
    /**
     * ツールチップ表示要否
     */
    enableToolTip: {
      type: Boolean,
      default: true
    },
    /**
     * ツールチップ表示位置（左）
     */
    tooltipLeft: {
      type: Boolean,
      default: false
    },
    /**
     * ツールチップ表示位置（上）
     */
    tooltipTop: {
      type: Boolean,
      default: false
    },
    /**
     * ツールチップ表示位置（右）
     */
    tooltipRight: {
      type: Boolean,
      default: false
    },
    /**
     * ツールチップ表示位置（下）
     */
    tooltipBottom: {
      type: Boolean,
      default: false
    },
    /**
     * ラベル不要
     */
    noLabel: {
      type: Boolean,
      default: false
    },
    /**
     * 必須マーク非表示
     */
    requiredMarkHidden: {
      type: Boolean,
      default: false
    },
    /**
     * defaultPickerType
     * 00:期間,01:From,02:To
     */
    defaultPickerType: {
      type: String,
      default: '00'
    },
    /**
     * 使用モード
     * ---------------------------------------------
     * 選択時のラジオボタンの表記が変わります。
     * 未指定時は検索用
     * ---------------------------------------------
     */
    useMode: {
      type: String,
      default: 'search'
    },
    /**
     * 月単位の値変更ボタンを表示
     */
    dispMonthJumper: {
      type: Boolean,
      default: false
    },
    /**
     * vc-date-picker:is-required
     * falseにすると、単一選択カレンダーで同じ値をクリックしたとき値が消える
     * (範囲選択は無関係)
     */
    calendarIsRequired: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    phtext: '',
    hasFocus: false,
    invalidMessage: '',
    isShowCalendar: false,
    defaultMax: '2999/12/31',
    defaultMin: '2000/01/01',
    // pickerType: '00',
    selectedMode: 0,
    calendarRangeDate: { start: null, end: null },
    selectedFrom: null,
    modelConfig: {
      type: 'string',
      mask: 'YYYY/MM/DD'
    },
    locale: {
      masks: {
        input: 'YYYY/MM/DD'
      }
    },
    // selectedSupport: null,
    pickerActionsForSearch: [
      { value: '00', label: '範囲を指定' },
      { value: '01', label: '指定日以降を対象' },
      { value: '02', label: '指定日以前を対象' }
    ],
    pickerActionsForInput: [
      { value: '00', label: '範囲を指定' },
      { value: '01', label: '開始日のみ指定' },
      { value: '02', label: '終了日のみ指定' }
    ],
    supportActions: [
      { value: 'today', label: '今日', usePicker: null },
      { value: 'yesterday', label: '昨日', usePicker: null },
      { value: 'last7Days', label: '過去7日間(今日を含まない)', usePicker: '00' },
      { value: 'thisMonth', label: '今月', usePicker: '00' },
      { value: 'thisMonthWithoutToday', label: '今月(前日まで)', usePicker: '00' },
      { value: 'prevMonth', label: '先月', usePicker: '00' }
    ],

    orgPickerType: '00',
    fromErrorMessage: '',
    toErrorMessage: ''
  }),
  computed: {
    pickerType: {
      get () {
        return this.orgPickerType
      },
      set (value) {
        // 範囲指定(値有り) → from指定(calendarRangeDate = start(値有り)) → 範囲指定(start:値有り,end:値無し) → to指定(calendarRangeDate = end(null))
        // 上記の操作を行うと、カレンダーの見た目上ではstartの値が入っている表示となる(実際の値はnullであるにも関わらず)
        // おそらくvc-date-pickerの内部的な表示に関する値が指定の変更についていけてないとかだと思うので、
        // 範囲指定と単一指定でvc-date-pickerを別けてそれぞれに値をもって表示非表示で制御すればなんとかなりそうな気がする

        const oldVal = this.orgPickerType

        console.log('computed pickerType newVal oldVal', value, oldVal)
        console.log('computed pickerType this.calendarRangeDate', this.calendarRangeDate)
        // 入力対象指定変更

        // 現仕様
        // '00'(範囲指定)に切り替えた場合、入力日付をfrom指定の時はstart、to指定の時はendに反映する
        // '01'(from指定) or '02'(to指定)に切り替えた場合、'00'(範囲指定)から切り替えた時はstart or endを反映し、それ以外の時はfromDate or toDateが切り替わる(対象が切り替わるので値は変更なし)

        this.selectedMode = 0

        if (value === '00') {
          const targetDate = this.calendarRangeDate ?? null
          this.setRangeDate(oldVal === '01' ? targetDate : null, oldVal === '02' ? targetDate : null)
        } else if (oldVal === '00') {
          const targetDate = (value === '01' ? this.calendarRangeDate?.start : this.calendarRangeDate?.end) ?? ''
          this.calendarRangeDate = targetDate
          if (this.calendarRangeDate === '') this.calendarRangeDate = null
        }

        console.log('computed pickerType result this.calendarRangeDate', this.calendarRangeDate)

        this.orgPickerType = value
      }
    },
    computedProps () {
      return {
        ...this.$props
      }
    },
    computedListeners () {
      return {
        ...this.$listeners
      }
    },
    innerFromDate: {
      get () {
        return this.fromDate
      },
      set (value) {
        if (value !== this.fromDate) this.$emit('change', value, this.toDate)
        this.$emit('update:fromDate', value)
      }
    },
    innerToDate: {
      get () {
        return this.toDate
      },
      set (value) {
        if (value !== this.toDate) this.$emit('change', this.fromDate, value)
        this.$emit('update:toDate', value)
      }
    },
    calendarMax () {
      if (this.max) {
        return this.max
      }
      return undefined
    },
    calendarMin () {
      if (this.min) {
        return this.min
      }
      return undefined
    },
    isRange () {
      return this.pickerType === '00'
    },
    dispFrom () {
      if (this.pickerType === '00') {
        if (this.selectedMode === 1) {
          return this.selectedFrom
        } else {
          return ![undefined, null, ''].includes(this.calendarRangeDate?.start) ? this.calendarRangeDate.start : '選択中'
        }
      } else if (this.pickerType === '01') {
        return ![undefined, null, ''].includes(this.calendarRangeDate) ? this.calendarRangeDate : '選択中'
      } else {
        return ''
      }
    },
    dispTo () {
      if (this.pickerType === '00') {
        if (this.selectedMode === 1) {
          return '選択中'
        } else {
          return ![undefined, null, ''].includes(this.calendarRangeDate?.end) ? this.calendarRangeDate.end : '選択中'
        }
      } else if (this.pickerType === '02') {
        return ![undefined, null, ''].includes(this.calendarRangeDate) ? this.calendarRangeDate : '選択中'
      } else {
        return ''
      }
    },
    selectedSupport: {
      get () {
        const d = new Date()
        if ((this.pickerType === '00' && this.calendarRangeDate?.start === date.getCurrentDate() && this.calendarRangeDate?.end === date.getCurrentDate()) || this.calendarRangeDate === date.getCurrentDate()) {
          return 'today'
        } else if ((this.pickerType === '00' && this.calendarRangeDate?.start === date.getAnyDate(-1) && this.calendarRangeDate?.end === date.getAnyDate(-1)) || this.calendarRangeDate === date.getAnyDate(-1)) {
          return 'yesterday'
        } else if (this.pickerType === '00' && this.calendarRangeDate?.start === date.getAnyDate(-7) && this.calendarRangeDate?.end === date.getAnyDate(-1)) {
          return 'last7Days'
        } else if (this.pickerType === '00' && this.calendarRangeDate?.start === date.getFirstDate(d.getFullYear(), d.getMonth() + 1) && this.calendarRangeDate?.end === date.getLastDate(d.getFullYear(), d.getMonth() + 1)) {
          return 'thisMonth'
        } else if (this.pickerType === '00' && this.calendarRangeDate?.start === date.getFirstDate(d.getFullYear(), d.getMonth() + 1) && this.calendarRangeDate?.end === date.getAnyDate(-1)) {
          return 'thisMonthWithoutToday'
        } else if (this.pickerType === '00' && this.calendarRangeDate?.start === date.getFirstDate(d.getFullYear(), d.getMonth()) && this.calendarRangeDate?.end === date.getLastDate(d.getFullYear(), d.getMonth())) {
          return 'prevMonth'
        } else {
          return null
        }
      }
    }
  },
  created () {
    this.orgPickerType = ['00', '01', '02'].includes(this.defaultPickerType) ? this.defaultPickerType : '00'
  },
  mounted () {
    // 日時比較用dayjsプラグイン
    dayjs.extend(customParseFormat)
    dayjs.extend(isSameOrAfter)
    dayjs.extend(isSameOrBefore)
  },
  methods: {
    onIconClick: function (e) {
      // アイコンボタンクリック

      // 現仕様
      // 入力情報をcalendarRangeDateに反映
      // selectedModeは0(入力前)に初期化
      // fromDateのみ：from指定
      // toDateのみ：to指定
      // 両方入力有り：範囲指定
      // 両方入力無し：defaultPickerType

      console.log('DdcalendarRangeDateBox.onIconClick fromDate - toDate : ', this.fromDate, this.toDate)

      const from = ![undefined, null, ''].includes(this.fromDate) ? this.fromDate : null
      const to = ![undefined, null, ''].includes(this.toDate) ? this.toDate : null

      if (from && to) {
        this.orgPickerType = '00'
        this.setRangeDate(from, to)
      } else if (from || to) {
        this.orgPickerType = from ? '01' : '02'
        this.calendarRangeDate = from ?? to
      } else {
        this.orgPickerType = ['00', '01', '02'].includes(this.defaultPickerType) ? this.defaultPickerType : '00'
        if ((['00', '01', '02'].includes(this.defaultPickerType) ? this.defaultPickerType : '00') === '00') {
          this.setRangeDate(null, null)
        } else {
          this.calendarRangeDate = null
        }
      }

      this.selectedMode = 0
      this.selectedFrom = null
    },
    onCalendarClick: function (e) {
      // カレンダー日付クリック

      // 現仕様
      // pickerTypeが'00'(範囲指定)以外の場合、DateBoxと同じ動作
      // '00'の場合、1回目は上部表示の設定と適用ボタンの無効化、2回目は実値の反映とダイアログを閉じる
      // min-max内以外の値の場合は無視する(v-date-pickerと違ってdisabled値をクリックしたときにクリックイベントが飛んでくる)

      console.log(e)
      console.log('calendarRangeDate is ', JSON.stringify(this.calendarRangeDate), ' - selectedMode is ', this.selectedMode)
      if (![undefined, null].includes(e) && (this.min === undefined || dayjs(e.id).isSameOrAfter(dayjs(this.min))) && (this.max === undefined || dayjs(e.id).isSameOrBefore(dayjs(this.max)))) {
        if (this.pickerType === '00') {
          if (this.selectedMode === 0) {
            this.selectedFrom = e.id.split('-').join('/')
            this.selectedMode = 1
          } else if (this.selectedMode === 1) {
            if (this.calendarRangeDate.start > this.calendarRangeDate.end) {
              this.setRangeDate(this.calendarRangeDate.end, this.calendarRangeDate.start)
            }
            this.syncParent(this.pickerType)
          }
        } else if (this.pickerType === '01' || this.pickerType === '02') {
          this.syncParent(this.pickerType)
        }
      }
    },
    hideCalendar: function (e) {
      this.isShowCalendar = false
    },
    /**
     * 入力補助
     */
    onClickSupportAction: function (val) {
      console.log(val)

      if (val === 'today') {
        if (this.pickerType === '00') {
          this.setRangeDate(date.getCurrentDate(), date.getCurrentDate())
        } else {
          this.calendarRangeDate = date.getCurrentDate()
        }
      } else if (val === 'yesterday') {
        if (this.pickerType === '00') {
          this.setRangeDate(date.getAnyDate(-1), date.getAnyDate(-1))
        } else {
          this.calendarRangeDate = date.getAnyDate(-1)
        }
      } else if (val === 'last7Days') {
        if (this.pickerType === '00') {
          this.setRangeDate(date.getAnyDate(-7), date.getAnyDate(-1))
        }
      } else if (val === 'thisMonth') {
        if (this.pickerType === '00') {
          const d = new Date()
          this.setRangeDate(date.getFirstDate(d.getFullYear(), d.getMonth() + 1), date.getLastDate(d.getFullYear(), d.getMonth() + 1))
        }
      } else if (val === 'thisMonthWithoutToday') {
        if (this.pickerType === '00') {
          const d = new Date()
          this.setRangeDate(date.getFirstDate(d.getFullYear(), d.getMonth() + 1), date.getAnyDate(-1))
        }
      } else if (val === 'prevMonth') {
        if (this.pickerType === '00') {
          const d = new Date()
          this.setRangeDate(date.getFirstDate(d.getFullYear(), d.getMonth()), date.getLastDate(d.getFullYear(), d.getMonth()))
        }
      }

      this.selectedMode = 0
      this.syncParent(this.pickerType)
    },
    onTekiyoClick: function () {
      this.syncParent(this.pickerType)
    },
    syncParent: function (pickerType) {
      /* 呼び出し元に反映 */
      console.log('syncParent this.calendarRangeDate', this.calendarRangeDate)

      if (pickerType === '00') {
        const from = this.calendarRangeDate?.start ?? null
        const to = this.calendarRangeDate?.end ?? null
        if (this.fromDate !== from || this.toDate !== to) this.$emit('change', from, to)
        this.$emit('update:fromDate', from)
        this.$emit('update:toDate', to)
      } else if (pickerType === '01') {
        if (this.fromDate !== (this.calendarRangeDate ?? null) || this.toDate !== null) this.$emit('change', this.calendarRangeDate ?? null, null)
        this.$emit('update:fromDate', this.calendarRangeDate ?? null)
        this.$emit('update:toDate', null)
      } else if (pickerType === '02') {
        if (this.fromDate !== null || this.toDate !== (this.calendarRangeDate ?? null)) this.$emit('change', null, this.calendarRangeDate ?? null)
        this.$emit('update:fromDate', null)
        this.$emit('update:toDate', this.calendarRangeDate ?? null)
      }

      this.$nextTick(() => {
        this[controls.VALIDATE_METHOD]()

        // 反映後は必ず閉じる
        // (キャンセルボタンがあるため、閉じられるまで反映しない)
        this.hideCalendar()
      })
    },
    setRangeDate: function (from, to) {
      const tmpRangeDate = { start: from, end: to }
      this.calendarRangeDate = Object.assign({}, tmpRangeDate)
    },
    handleShow () {
      this.$refs.calendar.adjustPageRange()
    },
    [controls.SET_INVALID_METHOD]: function (message) {
      this.$refs.fromDate[controls.SET_INVALID_METHOD](message)
      this.$refs.toDate[controls.SET_INVALID_METHOD](message)
    },
    [controls.GET_INVALID_METHOD]: function () {
      const result = (this.$refs.fromDate[controls.GET_INVALID_METHOD]() ?? '') + (this.$refs.toDate[controls.GET_INVALID_METHOD]() ?? '')
      return result !== '' ? result : undefined
    },
    [controls.CLEAR_INVALID_METHOD]: function () {
      this.$refs.fromDate[controls.CLEAR_INVALID_METHOD]()
      this.$refs.toDate[controls.CLEAR_INVALID_METHOD]()
    },
    [controls.VALIDATE_METHOD]: function () {
      this.$refs.fromDate[controls.VALIDATE_METHOD]()
      this.$refs.toDate[controls.VALIDATE_METHOD]()
    },
    onColosingDateButtonClick: function (day) {
      const baseDate = [undefined, null, ''].includes(this.innerToDate) ? [undefined, null, ''].includes(this.innerFromDate) ? date.getCurrentDate() : this.innerFromDate : this.innerToDate
      const baseYmd = baseDate.split('/')
      var tmpFromDate
      var tmpToDate
      if (day !== 99) {
        var tmpDate = this.monthAdd(-1, baseYmd.join('/'), 0).split('/')
        tmpDate[2] = day + 1
        tmpFromDate = tmpDate.join('/')
        baseYmd[2] = day
        tmpToDate = baseYmd.join('/')
      } else {
        tmpFromDate = date.getFirstDate(baseYmd[0], baseYmd[1])
        tmpToDate = date.getLastDate(baseYmd[0], baseYmd[1])
      }
      this.setRangeDate(tmpFromDate, tmpToDate)
      this.syncParent(this.pickerType)
    },
    onClosingPrevNextButtonClick: function (num) {
      console.log('onClosingPrevNextButtonClick', this.pickerType)
      var baseFromDate = this.innerFromDate
      var baseToDate = this.innerToDate
      var tmpFromDate = null
      var tmpToDate = null
      if (![undefined, null, ''].includes(baseFromDate)) {
        tmpFromDate = this.replacePartOfDate(this.monthAdd(num, baseFromDate, 0), baseFromDate)
      }
      if (![undefined, null, ''].includes(baseToDate)) {
        tmpToDate = this.replacePartOfDate(this.monthAdd(num, baseToDate, 0), baseToDate)
      }
      this.setRangeDate(tmpFromDate, tmpToDate)
      this.syncParent(this.pickerType)
    },
    // 日付部分をp2の日で置き換え
    replacePartOfDate: function (p1, p2) {
      var tmpDate = p1.split('/')
      var tmpDate2 = p2.split('/')
      var r = null
      if (['04', '06', '09', '11'].includes(tmpDate[1]) && tmpDate2[2] === '31') {
        r = date.getLastDate(tmpDate[0], tmpDate[1])
      } else if (['02'].includes(tmpDate[1]) && tmpDate2[2] >= '28') {
        r = date.getLastDate(tmpDate[0], tmpDate[1])
      } else if (['01', '03', '05', '07', '08', '10', '12'].includes(tmpDate[1]) && tmpDate2[2] >= '28') {
        r = date.getLastDate(tmpDate[0], tmpDate[1])
      } else {
        tmpDate[2] = tmpDate2[2]
        r = tmpDate.join('/')
      }
      return r
    },
    onMonthJumperButtonClick: function (mode) {
      const d = new Date()
      var tmpFromDate
      var tmpToDate
      if (mode === 0) {
        tmpFromDate = date.getFirstDate(d.getFullYear(), d.getMonth() + 1)
        tmpToDate = date.getLastDate(d.getFullYear(), d.getMonth() + 1)
      } else if (mode === 1) {
        if (!this.innerFromDate && !this.innerToDate) {
          tmpFromDate = date.getFirstDate(d.getFullYear(), d.getMonth())
          tmpToDate = date.getLastDate(d.getFullYear(), d.getMonth())
        } else {
          tmpFromDate = ![undefined, null, ''].includes(this.innerFromDate) ? this.monthAdd(-1, this.innerFromDate, 0) : this.innerFromDate
          tmpToDate = ![undefined, null, ''].includes(this.innerToDate) ? this.monthAdd(-1, this.innerToDate, 1) : this.innerToDate
        }
      } else if (mode === 2) {
        if (!this.innerFromDate && !this.innerToDate) {
          tmpFromDate = date.getFirstDate(d.getFullYear(), d.getMonth() + 2)
          tmpToDate = date.getLastDate(d.getFullYear(), d.getMonth() + 2)
        } else {
          tmpFromDate = ![undefined, null, ''].includes(this.innerFromDate) ? this.monthAdd(1, this.innerFromDate, 0) : this.innerFromDate
          tmpToDate = ![undefined, null, ''].includes(this.innerToDate) ? this.monthAdd(1, this.innerToDate, 1) : this.innerToDate
        }
      }
      this.setRangeDate(tmpFromDate, tmpToDate)
      this.selectedMode = 0
      this.syncParent(this.pickerType)
    },
    monthAdd: function (num, d, p) {
      if (typeof d === 'string') {
        var converted = Date.parse(d)
        var myDate = new Date(converted)
        if (isNaN(myDate)) {
          var arys = d.split('/')
          myDate = new Date(arys[0], --arys[1], arys[2])
        }
        d = myDate
      }
      var resultDate = new Date(d.getTime())
      resultDate.setMonth(d.getMonth() + num)
      if (d.getDate() > resultDate.getDate()) {
        resultDate.setDate(0)
      }
      if (p < 1) {
        return date.getFirstDate(resultDate.getFullYear(), resultDate.getMonth() + 1)
      } else {
        return date.getLastDate(resultDate.getFullYear(), resultDate.getMonth() + 1)
      }
    }
  }
}
</script>
<style scoped>
.range-style {
  height:32px !important;
  overflow: hidden;
}
.range-style-message-area {
  display: flex;
  margin: 0 1px;
}
.range-style-message {
  font-size: 12px;
  line-height: 12px;
  word-break: break-word;
  overflow-wrap: break-word;
  word-wrap: break-word;
  -webkit-hyphens: auto;
  -ms-hyphens: auto;
  hyphens: auto;
  padding: 2px 4px 2px 12px;
}
.v-picker.v-card.v-picker--date {
  position: absolute;
  z-index: 500;
}
.mdi-calendar::before {
  color: #2196F3;
}
.v-menu__content.theme--light {
  width: 760px !important;
  height: 368px !important;
  background-color: #FFF;
}
.radio-inline__input {
    clip: rect(1px, 1px, 1px, 1px);
    position: absolute !important;
}
.radio-inline__label {
    display: inline-block;
    padding: 0.5rem 1rem;
    margin-right: 18px;
    border-radius: 3px;
    transition: all .2s;
}
.radio-inline__input:checked + .radio-inline__label {
    background: #B54A4A;
    color: #fff;
    text-shadow: 0 0 1px rgba(0,0,0,.7);
}
.radio-inline__input:focus + .radio-inline__label {
    outline-color: #4D90FE;
    outline-offset: -2px;
    outline-style: auto;
    outline-width: 5px;
}
.input-info {
  font-size:small;
  font-weight:bold;
}
/** 指定方法用 */
::v-deep .v-input--selection-controls {
    margin-top: 0px !important;
    padding-top: 1px !important;
}
::v-deep .v-radio>.v-label{
    padding-top: 1px !important;
    font-size:0.625rem !important;
    font-weight: bold !important;
}
/** 入力補助用 */
.support {
  margin: 1px;
  width: 230px;
  background: #f8f8f8;
  color: #1F2B38;
  padding: 5px 10px;
  border-radius: 3px;
  display: inline-block;
  cursor: pointer;
}
input[type="radio"] {
  display: none;
}
input[name="support"]:hover + label {
  background-color: #e0e8ff;
  font-weight: bold;
}
input[name="support"]:checked + label {
  background-color: #bee3f8;
  font-weight: bold;
}
.month-jumper {
  margin-left: 8px !important;
  padding-top: 4px !important;
  margin-bottom: 4px !important;
  height: 20px;
  text-align: left;
  vertical-align: bottom;
  font: normal normal bold 14px/25px YuGothic;
  letter-spacing: 0px;
  color: #1F2B38 !important;
  opacity: 1;
}

/** 入力補助２ */
.support-input-date {
  background: #bee3f8 0% 0% no-repeat padding-box !important;
  overflow: hidden;
  margin-top: 3px;
  margin-left: 4px;
  padding-top: 2px;
  padding-bottom: 1px;
  padding-left: 4px;
  padding-right: 5px;
  font: normal normal bold 0.6rem / 0.875 YuGothic;
  vertical-align: text-top;
  height: 18px !important;
}
</style>
